const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill:gray;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-272 2216.103)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 24,
  height: 24,
  transform: "translate(272 -2216.103)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(272 -2213.766)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.155 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M330.644,79.934h-18.9a.424.424,0,0,1-.423-.424v-6a.424.424,0,1,1,.847,0v5.578h18.055V61.031H312.166v5.58a.424.424,0,0,1-.847,0v-6a.424.424,0,0,1,.423-.424h18.9a.424.424,0,0,1,.424.424v18.9A.424.424,0,0,1,330.644,79.934Z",
  transform: "translate(-311.319 -60.184)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9.451)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M323.6,72.843H306.551a.424.424,0,1,1,0-.848H323.6a.424.424,0,1,1,0,.848Z",
  transform: "translate(-306.127 -71.995)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.598 6.003)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M323.544,75.431a.424.424,0,0,1-.3-.723l3.149-3.15-3.149-3.149a.424.424,0,1,1,.6-.6l3.449,3.448a.424.424,0,0,1,0,.6l-3.449,3.45A.425.425,0,0,1,323.544,75.431Z",
  transform: "translate(-323.121 -67.686)"
}))));
function SvgIconLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.6afd57d68c624a6dc456e0281d1b371f.svg";
export { ForwardRef as ReactComponent };